<template>
  <div style="padding: 0 16px">
    <a-skeleton :loading="spinning" active>
      <a-table :columns="columns" :pagination="pagination" :data-source="changelogs" size="small" row-key="index" @change="handleTableChange">
        <span slot="number" slot-scope="record">{{ record.index }}</span>
        <span slot="operator" slot-scope="operator">{{ operator ? operator.nickname : '系统' }}</span>
        <span slot="diffItem" slot-scope="record">
          <div v-for="(item, key) in record.value_diff" :key="key">{{ item.label }}</div>
        </span>
        <span slot="before" slot-scope="record">
          <span>
            <span v-for="(item, key) in record.value_diff" :key="key">
              <div v-if="['name', 'point', 'project_id', 'version_title', 'pre_start_time', 'pre_end_time'].includes(item.value)">{{ item.before || '--' }}</div>
              <div v-else-if="item.value === 'requirement_id'">
                <a v-if="item.before" :href="link(item.after)" target="_blank">{{ item.before }}</a>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'status'">
                <a-badge v-if="item.before !== null && taskStatus[item.before]" :status="taskStatus[item.before].status" :color="taskStatus[item.before].color" :text="taskStatus[item.before].label" />
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'priority'">
                <a-tag v-if="item.before" :color="taskPrioritys[item.before].color"> {{ taskPrioritys[item.before].label }} </a-tag>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'description'">
                <a v-if="item.before !== null" @click="onPreview(item.before, '「变更前」描述')">查看详情</a>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'handlers'">
                <user-profiles v-if="item.before && item.before.length > 0" :value="item.before" avatar />
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'ai_score'">
                <a v-if="item.before !== null" @click="onAiScoreLogPreview(item.before, '「变更前」AI评分')">查看详情</a>
                <span v-else>--</span>
              </div>
              <div v-else>--</div>
            </span>
          </span>
        </span>
        <span slot="after" slot-scope="record">
          <span>
            <span v-for="(item, key) in record.value_diff" :key="key">
              <div v-if="['name', 'point', 'project_id', 'version_title', 'pre_start_time', 'pre_end_time'].includes(item.value)">{{ item.after || '--' }}</div>
              <div v-else-if="item.value === 'requirement_id'">
                <a v-if="item.after" :href="link(item.after)" target="_blank">{{ item.after }}</a>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'status'">
                <a-badge v-if="item.after && taskStatus[item.after]" :status="taskStatus[item.after].status" :color="taskStatus[item.after].color" :text="taskStatus[item.after].label" />
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'priority'">
                <a-tag v-if="item.after" :color="taskPrioritys[item.after].color"> {{ taskPrioritys[item.after].label }} </a-tag>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'description'">
                <a v-if="item.after !== null" @click="onPreview(item.after, '「变更后」描述')">查看详情</a>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'handlers'">
                <user-profiles v-if="item.after && item.after.length > 0" :value="item.after" avatar />
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'ai_score'">
                <a v-if="item.after !== null" @click="onAiScoreLogPreview(item.after, '「变更后」AI评分')">查看详情</a>
                <span v-else>--</span>
              </div>
              <div v-else>--</div>
            </span>
          </span>
        </span>
      </a-table>
    </a-skeleton>
    <preview-modal ref="previewModal" />
    <ai-score-log-view-modal ref="aiScoreLogViewModal" />
  </div>
</template>

<script>
import { taskChangelog } from '@/api/project/task';
import { taskStatus, taskPrioritys } from '@/utils/dictionary';

import PreviewModal from '@/pages/project/components/PreviewModal';
import AiScoreLogViewModal from '@/pages/project/task/components/AiScoreLogViewModal';

const columns = [
  {
    title: '序号',
    width: '5%',
    align: 'center',
    scopedSlots: { customRender: 'number' }
  },
  {
    title: '操作人',
    width: '10%',
    align: 'center',
    dataIndex: 'operator',
    key: 'operator',
    scopedSlots: { customRender: 'operator' }
  },
  {
    title: '操作时间',
    width: '15%',
    align: 'center',
    key: 'created_time',
    dataIndex: 'created_time'
  },
  {
    title: '变更类型',
    width: '10%',
    align: 'center',
    key: 'operation_alias',
    dataIndex: 'operation_alias'
  },
  {
    title: '变更项',
    width: '10%',
    align: 'center',
    scopedSlots: { customRender: 'diffItem' }
  },
  {
    title: '变更前',
    align: 'center',
    width: '25%',
    scopedSlots: { customRender: 'before' }
  },
  {
    title: '变更后',
    align: 'center',
    width: '25%',
    scopedSlots: { customRender: 'after' }
  }
];
export default {
  components: { PreviewModal, AiScoreLogViewModal },
  props: {
    sourceId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      columns,
      taskStatus,
      taskPrioritys,
      spinning: true,
      projectId: parseInt(this.$route.params.project_id) || null,
      pagination: {
        size: 'small',
        total: 0,
        pageSize: this.$store.getters.pageSize,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'],
        showTotal: total => `共 ${total} 条`
      },
      changelogs: [],
      changelogItems: {
        name: { value: 'name', label: '名称' },
        point: { value: 'point', label: '任务Point数' },
        status: { value: 'status', label: '状态' },
        pre_start_time: { value: 'pre_start_time', label: '计划开始时间' },
        pre_end_time: { value: 'pre_end_time', label: '计划结束时间' },
        priority: { value: 'priority', label: '优先级' },
        handlers: { value: 'handlers', label: '处理人' },
        description: { value: 'description', label: '描述' },
        requirement_id: { value: 'requirement_id', label: '关联需求' },
        version_title: { value: 'version_title', label: '版本' },
        project_id: { value: 'project_id', label: '项目' },
        ai_score: { value: 'ai_score', label: 'AI评分' }
      }
    };
  },
  computed: {
    diff() {
      return data => {
        const items = [];
        const itemKeys = Object.keys(this.changelogItems);
        for (const key in data) {
          if (itemKeys.includes(key)) {
            items.push({
              ...this.changelogItems[key],
              ...data[key]
            });
          }
        }
        return items;
      };
    },
    link() {
      return value => {
        return this.$router.resolve({
          name: 'page:project:story:detail',
          query: { storyId: value }
        }).href;
      };
    }
  },
  created() {
    this.getTaskChangelog();
  },
  methods: {
    getTaskChangelog() {
      taskChangelog({
        task_id: this.sourceId,
        project_id: this.projectId,
        page_size: this.pagination.pageSize,
        page_number: this.pagination.current
      })
        .then(res => {
          this.pagination.total = res.data.total;
          this.changelogs = res.data.items.map((changelog, index) => {
            return {
              index: index + 1,
              ...changelog,
              value_diff: this.diff(changelog.value_diff)
            };
          });
          this.spinning = false;
        })
        .catch(() => {
          this.spinning = false;
        });
    },

    onPreview(content, title = null) {
      this.$nextTick(() => {
        this.$refs.previewModal.onOpen(content, title);
      });
    },

    onAiScoreLogPreview(content, title = null) {
      this.$nextTick(() => {
        this.$refs.aiScoreLogViewModal.onOpen(content, title);
      });
    },

    handleTableChange(pagination) {
      this.pagination = pagination;
      this.getTaskChangelog();
    }
  }
};
</script>
<style lang="less" scoped>
.diff-item {
  display: block;
}

.ql-container.ql-snow {
  border: none;
}
</style>
